/**
 * 主要存放，各种组件内使用频率非常高方法,避免修改时到处重复修改处理
 * 方法内依赖组件情况下,调用方法时把this作用域call等绑定进来,绑定作用域不能用箭头函数
 */

import { getZeroTime } from '~/common/utils';
import {trackEventApi} from '~/common/utils/track'

export const toJumpLink = async function(row,$route) {
  //内容跳转逻辑
  let href = '';
  this.qr_code = this.qr_code || '';
  // const jumpPath = (row.type == 100||row.type == 903) ? '/srvContent/view' : '/content/view';
  const jumpPath = '/srvContent/view'; // 将问答、问卷、邀请、直播类型的公开内容，都纳入SEO项目(2024/5/13 5月优化需求)
  if (row.turn_invite || row.type == '400') {
    let invitorDetail = await getInvitorDetail.call(this, row);
    this.qr_code = invitorDetail?.data?.qr_code || '';
  }
  let column_id = row.column_id || '';
  const biz_id = row.biz_id;
  let slug = this.$route.query.slug || row.slug || '';
  if (row.type == '400') {
    // 邀请类型
    if (row.sub_link) {
      // 有邀请链接跳转，无则跳转到展示页
      let isHasQmark = row.sub_link.includes('?'); // url是否包含问号
      let remainLink = isHasQmark ? `&qr_code=${this.qr_code}&biz_id=${biz_id}` : `?qr_code=${this.qr_code}&biz_id=${biz_id}`;
      href = `${row.sub_link}${remainLink}`;
    } else {
      let route2 = this.$router.resolve({
        path: jumpPath,
        query: { qr_code: this.qr_code, id: row.publishing_id || row.publish_id, column_id, biz_id, slug }
      });
      href = window.location.origin + route2.route.fullPath;
    }
  } else if (row.type == '500' && row.sub_link) {
    // 有广告链接跳转，无则跳转到展示页
    let isHasQmark = row.sub_link.includes('?'); // url是否包含问号
    let remainLink = isHasQmark ? `&biz_id=${biz_id}` : `?biz_id=${biz_id}`;
    href = `${row.sub_link}${remainLink}`;
  } else {
    let route2 = this.$router.resolve({
      path: jumpPath,
      query: { id: row.publishing_id || row.publish_id, column_id, biz_id, slug }
    });
    href = window.location.origin + route2.route.fullPath;
  }
  if (!href.includes('qr_code=')) {
    let isHasQmark = href.includes('?'); // url是否包含问号
    href += isHasQmark ? `&qr_code=${this.qr_code}` : `?qr_code=${this.qr_code}`;
  }
  if (['/', '/portal/home'].includes(this.$route.path) || this.$route.query.columnType === '4' || row.columnType == 4) {
    //公开栏目
    href += '&columnType=4';
  }
  href = href.includes('http') ? href : '//' + href;
  trackEventApi({
    $route,
    value: [
      {page_type:'list',menu:'媒体',click_url: href,component_name:'内容链接跳转'},
      {page_type:'display',menu:'', object_type:'CMS', url: href, refer_url: $route.fullPath, component_name:''},
    ]
  })
  window.open(href, '_blank'); // 新开窗口
};
//内容链接拼接url
export const getUrl = function(row) {
  let href = '';
  const jumpPath = '/srvContent/view';
  let slug = row.slug || '';
  if (row.sub_link) {
    // 有广告链接跳转，无则跳转到展示页
    href = row.sub_link;
  } else {
    let { publishing_id, column_id, biz_id } = row;
    href = window.location.origin + jumpPath + '?publishing_id=' + publishing_id + '&column_id=' + column_id + '&biz_id=' + biz_id + '&slug=' + slug;
    if (row.columnType == 4) href += '&columnType=4'; //公开栏目
  }
  return href.includes('http') ? href : '//' + href;
};
//查询邀请人详细的信息 获取邀请码
export const getInvitorDetail = function(row) {
  return this.$axios.$get('/rest/portal/cms/v3/content/invitor/detail', { params: { publishing_id: row.publishing_id } }).catch(() => {});
};

export const jumpMore = function({ type, column_id, slug }) {
  //各组件跳转至更多页的逻辑
  let href = `/srvContent/works/more?type=${type}&column_id=${column_id}&slug=${slug}`;
  if (['/', '/portal/home'].includes(this.$route.path) || this.$route.query.columnType === '4') {
    href += '&columnType=4';
  }
  window.open(href, '_blank');
};
//获取列表的查询条件
export const getSearchParams = function({ nowTab, shop_id }) {
  //获取上周一-周末时间
  function getTime(n) {
    var now = new Date();
    var year = now.getFullYear();
    //因为月份是从0开始的,所以获取这个月的月份数要加1才行
    var month = now.getMonth() + 1;
    var date = now.getDate();
    var day = now.getDay();
    //判断是否为周日,如果不是的话,就让今天的day-1(例如星期二就是2-1)
    if (day !== 0) {
      n = n + (day - 1);
    } else {
      n = n + day;
    }
    if (day) {
      //这个判断是为了解决跨年的问题
      if (month > 1) {
        month = month;
      }
      //这个判断是为了解决跨年的问题,月份是从0开始的
      else {
        year = year - 1;
        month = 12;
      }
    }
    now.setDate(now.getDate() - n);
    year = now.getFullYear();
    month = now.getMonth() + 1;
    date = now.getDate();
    var s = year + '-' + (month < 10 ? '0' + month : month) + '-' + (date < 10 ? '0' + date : date);
    return new Date(s);
  }
  let params, start_publishing_at, end_publishing_at;
  //{ hotArticle: '热文', hotReview: '热评', hotSearch: '热搜', newest: '最新', lastWeek: '上周', lastMonth: '上月', recommend: '推荐', selfRecommend: '自荐', invitation: '邀请', notice: '公告', statistics: '统计', label: 'common.tags', nowTab: '' }
  switch (nowTab) {
    case 'notice':
      params = { param: { article_type: 50, shop_id }, current: 1, page_size: 999, order_bys: 'notice_time|desc' };
      break;
    case 'hotArticle':
      params = { param: { article_type: 20, shop_id }, current: 1, page_size: 8, order_bys: 'read_count|desc' };
      break;
    case 'hotReview':
      params = { param: { article_type: 20, shop_id }, current: 1, page_size: 8, order_bys: 'comment_count|desc' };
      break;
    case 'hotSearch':
      params = { param: { article_type: 0, shop_id }, current: 1, page_size: 8, order_bys: 'read_count|desc' };
      break;
    case 'newest':
      params = { param: { article_type: 30, shop_id }, current: 1, page_size: 8, order_bys: 'publishing_at|desc' };
      break;
    case 'lastWeek':
      start_publishing_at = getZeroTime(getTime(7));
      end_publishing_at = getZeroTime(getTime(1));
      params = { param: { article_type: 30, shop_id, start_publishing_at, end_publishing_at }, current: 1, page_size: 8, order_bys: 'publishing_at|desc' };
      break;
    case 'lastMonth':
      let startdate = new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1);
      let date = new Date();
      let day = new Date(date.getFullYear(), date.getMonth(), 0).getDate();
      let enddate = new Date(new Date().getFullYear(), new Date().getMonth() - 1, day);
      start_publishing_at = getZeroTime(startdate);
      end_publishing_at = getZeroTime(enddate);
      params = { param: { article_type: 30, shop_id, start_publishing_at, end_publishing_at }, current: 1, page_size: 8, order_bys: 'publishing_at|desc' };
      break;
    case 'recommend':
      params = { param: { article_type: 40, shop_id }, current: 1, page_size: 8, order_bys: 'publishing_at|desc' };
      break;
    case 'selfRecommend':
      params = { param: { article_type: 40, shop_id }, current: 1, page_size: 8, order_bys: 'collect_count|desc,comment_count|desc,share_count|desc' };
      break;
    case 'invitation':
      params = { param: { article_type: 40, shop_id, type: 400 }, current: 1, page_size: 8, order_bys: 'publishing_at|desc' };
      break;
    default:
      break;
  }
  return params;
};
